<template>
  <div class="mt-5">
    <div class="text-white mt-10">Su solicitud ha sido creada</div>
    <div class="text-sm text-teal-200 mt-5 mb-1">Su código de recarga es</div>
    <div class="flex flex-col items-center">
      <div class="bg-gray-100 rounded-full px-3 py-1 text-2xl font-bold text-teal-700 mb-2">{{ codigoOperacion }}</div>
    </div>
    <button @click="inicio" class="bg-paleta-3 hover:bg-blue-700 text-white font-bold mt-5 py-2 px-4 rounded">Inicio</button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  methods: {
    inicio: function() {
      this.$router.push("/menu");
    }
  },
  computed: {
    ...mapState({
      codigoOperacion: state => state.recarga.codigoOperacion
    })
  }
};
</script>
